import { observeLazySources, observeResourcesInContainer } from './modules/lazy-sources-loader.js';
import { loadMore } from './modules/load-more';
import { initNewsBlocksAnalytics } from './modules/analytics.js';

/* need for old browsers without defer */
document.addEventListener(
  `DOMContentLoaded`,
  () => {
    /* initialization of lazy loading */
    const lazySourceObserver = observeLazySources();

    const $loadMoreButton = document.querySelector(`.js-load-more-button`);
    const $articlesContainer = document.querySelector(`.js-articles`);

    loadMore(
      $articlesContainer,
      $loadMoreButton,
      (nextPage) =>
        `${window.Site.fullDomain}/ajax/categories/${window.Site.entity_id}/articles/?page=${nextPage}`,
      () => observeResourcesInContainer(lazySourceObserver)($articlesContainer),
    );

    initNewsBlocksAnalytics();
  },
  false,
);
